"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchSection = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var Card_1 = require("@amzn/atoz-web/Card");
var Text_1 = require("@amzn/atoz-web/Text");
var View_1 = require("@amzn/atoz-web/View");
var Col_1 = require("@amzn/atoz-web/Col");
var Hr_1 = require("@amzn/atoz-web/Hr");
var Row_1 = require("@amzn/atoz-web/Row");
var Modal_1 = require("@amzn/atoz-web/Modal");
var PunchModal_1 = require("../../../views/PunchModal");
var PunchCorrectionConfirmationModal_1 = require("../../../views/PunchCorrectionConfirmationModal");
var views_1 = require("../../../views");
var empty_clock_svg_1 = __importDefault(require("../../../assets/images/empty-clock.svg"));
var luxon_1 = require("luxon");
var hooks_1 = require("../../../hooks");
var PunchCorrectionCard_1 = require("../../../views/PunchCorrectionCard");
var DateManagement_1 = require("../../../utils/DateManagement");
var __1 = require("../../..");
var Theme_1 = require("@amzn/atoz-web/Theme");
var PunchDeletionConfirmationModal_1 = require("../../../views/PunchDeletionConfirmationModal");
var PunchToastModalTypes_1 = require("../../../views/PunchToastModal/PunchToastModalTypes");
var PunchToastModalState;
(function (PunchToastModalState) {
    PunchToastModalState[PunchToastModalState["CLOSE"] = 0] = "CLOSE";
    PunchToastModalState[PunchToastModalState["SUBMIT_PUNCH"] = 1] = "SUBMIT_PUNCH";
    PunchToastModalState[PunchToastModalState["DELETE_PUNCH"] = 2] = "DELETE_PUNCH";
    PunchToastModalState[PunchToastModalState["ACCEPT_PUNCH_CORRECTION"] = 3] = "ACCEPT_PUNCH_CORRECTION";
    PunchToastModalState[PunchToastModalState["UPDATE_PUNCH_CORRECTION"] = 4] = "UPDATE_PUNCH_CORRECTION";
})(PunchToastModalState || (PunchToastModalState = {}));
var PunchSection = function (_a) {
    var punchesTimeSegments = _a.punchesTimeSegments, ctkPolicy = _a.ctkPolicy, hasUnverifiedMissedPunchLimit = _a.hasUnverifiedMissedPunchLimit, militaryTime = _a.militaryTime, selectedDate = _a.selectedDate, associateInfo = _a.associateInfo, punchAutomationPolicy = _a.punchAutomationPolicy, punchCorrections = _a.punchCorrections, refetch = _a.refetch;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = react_1.default.useState(true), expandSection = _b[0], setExpandSection = _b[1];
    var _c = react_1.default.useState(PunchToastModalState.CLOSE), punchToastModalState = _c[0], setPunchToastModalState = _c[1];
    var _d = react_1.default.useState(false), hideErrorModal = _d[0], setHideErrorModal = _d[1];
    var punchTotal = (punchesTimeSegments || []).reduce(function (acc, cur) {
        var timeInCount = cur.startDateTime ? 1 : 0;
        var timeOutCount = cur.endDateTime ? 1 : 0;
        return acc + timeInCount + timeOutCount;
    }, 0);
    var missedPunchTotal = 2 * ((punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.length) || 0) - punchTotal;
    var setExpandSectionback = react_1.default.useCallback(function (event) {
        if (event) {
            event.stopPropagation();
        }
        setExpandSection(!expandSection);
    }, [expandSection]);
    var _e = (0, hooks_1.useSubmitPunch)(__assign(__assign({}, associateInfo), { ctkPolicy: ctkPolicy })), _f = _e.submitPunchState, submitPunchLoading = _f.loading, submitPunchTime = _f.data, submitPunchError = _f.error, submitPunchRetry = _f.retry, submitPunch = _e.submitPunch;
    var _g = (0, hooks_1.useDeletePunch)(associateInfo), _h = _g.deletePunchState, deletePunchLoading = _h.loading, deletePunchTime = _h.data, deletePunchError = _h.error, deletePunchRetry = _h.retry, deletePunch = _g.deletePunch;
    var _j = (0, hooks_1.useAcceptPunchCorrection)(associateInfo), _k = _j.acceptPunchCorrectionState, acceptPunchCorrectionLoading = _k.loading, acceptCorrectionId = _k.data, acceptPunchCorrectionError = _k.error, acceptPunchCorrectionRetry = _k.retry, acceptPunchCorrection = _j.acceptPunchCorrection;
    var _l = (0, hooks_1.useUpdatePunchCorrection)(associateInfo), _m = _l.updatePunchCorrectionState, updatePunchCorrectionLoading = _m.loading, updateCorrectionData = _m.data, updatePunchCorrectionError = _m.error, updatePunchCorrectionRetry = _m.retry, updatePunchCorrection = _l.updatePunchCorrection;
    var punchLoading = submitPunchLoading ||
        deletePunchLoading ||
        acceptPunchCorrectionLoading ||
        updatePunchCorrectionLoading;
    var showPunchToast = !punchLoading &&
        !submitPunchError &&
        !deletePunchError &&
        !acceptPunchCorrectionError &&
        !updatePunchCorrectionError &&
        punchToastModalState != PunchToastModalState.CLOSE &&
        (!!submitPunchTime ||
            !!deletePunchTime ||
            !!acceptCorrectionId ||
            !!updateCorrectionData);
    var closePunchToastModal = function () {
        setPunchToastModalState(PunchToastModalState.CLOSE);
        refetch();
    };
    var renderPunchToastModal = function () {
        var title;
        var text;
        if (punchToastModalState == PunchToastModalState.SUBMIT_PUNCH) {
            title = t('time_and_attendance_PunchToastModal_MissedPunch_Title');
            var punchDateTime = luxon_1.DateTime.fromISO(submitPunchTime);
            text = t('time_and_attendance_PunchToastModal_MissedPunch_Text', {
                punchDate: punchDateTime.toLocaleString({
                    month: 'long',
                    day: 'numeric'
                }),
                punchTime: punchDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
            });
        }
        else if (punchToastModalState == PunchToastModalState.DELETE_PUNCH) {
            title = t('time_and_attendance_PunchToastModal_PunchDeleted');
            var punchDateTime = luxon_1.DateTime.fromISO(deletePunchTime);
            text = t('time_and_attendance_PunchToastModal_DeletePunch_Text', {
                punchDate: punchDateTime.toLocaleString({
                    month: 'long',
                    day: 'numeric'
                }),
                punchTime: punchDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
            });
        }
        else {
            var correctionId_1 = punchToastModalState ==
                PunchToastModalState.ACCEPT_PUNCH_CORRECTION
                ? acceptCorrectionId
                : updateCorrectionData === null || updateCorrectionData === void 0 ? void 0 : updateCorrectionData.updateCorrectionResult.correctionId;
            var punchCorrection = punchCorrections === null || punchCorrections === void 0 ? void 0 : punchCorrections.find(function (correction) { return correction.correctionId == correctionId_1; });
            var correctionDateTime = punchCorrection
                ? luxon_1.DateTime.fromISO(punchCorrection.correctionDateTime)
                : luxon_1.DateTime.now();
            title = t('time_and_attendance_PunchToastModal_PunchCorrection_Title');
            text = t('time_and_attendance_PunchToastModal_PunchCorrection_Text', {
                correctionDate: correctionDateTime.toLocaleString({
                    month: 'long',
                    day: 'numeric'
                }),
                correctionTime: correctionDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE)
            });
        }
        return (react_1.default.createElement(Modal_1.Modal, { isOpen: showPunchToast, close: closePunchToastModal },
            react_1.default.createElement(views_1.PunchToastModal, { title: title, text: text, status: PunchToastModalTypes_1.PunchToastModalStatus.success, closeModal: closePunchToastModal })));
    };
    var punchError = !punchLoading &&
        !hideErrorModal &&
        (!!submitPunchError ||
            !!deletePunchError ||
            !!acceptPunchCorrectionError ||
            !!updatePunchCorrectionError);
    var renderPunchErrorModal = function () {
        var retry = function () {
            setHideErrorModal(false);
            if (submitPunchError) {
                setPunchToastModalState(PunchToastModalState.SUBMIT_PUNCH);
                submitPunchRetry();
            }
            else if (deletePunchError) {
                setPunchToastModalState(PunchToastModalState.DELETE_PUNCH);
                deletePunchRetry();
            }
            else if (acceptPunchCorrectionError) {
                setPunchToastModalState(PunchToastModalState.ACCEPT_PUNCH_CORRECTION);
                acceptPunchCorrectionRetry();
            }
            else if (updatePunchCorrectionError) {
                setPunchToastModalState(PunchToastModalState.UPDATE_PUNCH_CORRECTION);
                updatePunchCorrectionRetry();
            }
        };
        var close = function () { return setHideErrorModal(true); };
        if (deletePunchError) {
            var title = t('time_and_attendance_PunchToastModal_Error');
            var textKey = deletePunchError.statusCode === 404
                ? 'time_and_attendance_PunchToastModal_DeletePunch_DuplicateDeletionErrorText'
                : 'time_and_attendance_PunchToastModal_DeletePunch_GeneralErrorText';
            var text = t(textKey);
            return (react_1.default.createElement(Modal_1.Modal, { isOpen: !hideErrorModal, close: close, dataTestId: "deletion-error-modal" },
                react_1.default.createElement(views_1.PunchToastModal, { title: title, text: text, status: PunchToastModalTypes_1.PunchToastModalStatus.error, dataTestId: textKey, closeModal: close })));
        }
        else {
            return (react_1.default.createElement(Modal_1.Modal, { isOpen: punchError, close: close },
                react_1.default.createElement(__1.PunchErrorModal, { retry: retry, close: close })));
        }
    };
    var renderPunchModal = function (_a) {
        var close = _a.close;
        return (react_1.default.createElement(PunchModal_1.PunchModal, { ctkPolicy: ctkPolicy, currentSelectedDate: selectedDate, militaryTime: militaryTime, close: close, submit: function (punchTime, punchDate, useMilitaryTime) {
                setPunchToastModalState(PunchToastModalState.SUBMIT_PUNCH);
                setHideErrorModal(false);
                submitPunch(punchTime, punchDate, useMilitaryTime);
                close();
            }, isMissedPunchModal: true, hasUnverifiedMissedPunchLimit: hasUnverifiedMissedPunchLimit, associateInfo: associateInfo }));
    };
    var renderNoPunchClock = function () {
        return expandSection &&
            (punchesTimeSegments === undefined || !punchesTimeSegments.length) && (react_1.default.createElement(Col_1.Col, { alignItems: "center", dataTestId: "PunchSectionNoPunchClock" },
            react_1.default.createElement(StyledClock, { src: empty_clock_svg_1.default, alt: "Empty Clock" }),
            react_1.default.createElement(Text_1.Text, { textAlign: "center", fontSize: "T300" }, t('time_and_attendance_PunchSection_NoPunches'))));
    };
    var renderPunchList = function () {
        return expandSection &&
            punchesTimeSegments &&
            !!punchesTimeSegments.length && (react_1.default.createElement(View_1.View, null, punchesTimeSegments.map(function (punchTime, i) {
            var _a, _b, _c, _d;
            return (react_1.default.createElement(View_1.View, { key: "".concat(punchTime.startDateTime, "-").concat(punchTime.endDateTime) },
                react_1.default.createElement(views_1.PunchCard, { timeIn: punchTime.startDateTime
                        ? luxon_1.DateTime.fromISO(punchTime.startDateTime)
                        : null, timeOut: punchTime.endDateTime
                        ? luxon_1.DateTime.fromISO(punchTime.endDateTime)
                        : null, timeInDeletable: (_b = (_a = punchTime.eligibility) === null || _a === void 0 ? void 0 : _a.startTimeDeletable) !== null && _b !== void 0 ? _b : false, timeOutDeletable: (_d = (_c = punchTime.eligibility) === null || _c === void 0 ? void 0 : _c.endTimeDeletable) !== null && _d !== void 0 ? _d : false, militaryTime: militaryTime, renderPunchDeletionConfirmationModal: function (_a, punchDateTime) {
                        var close = _a.close;
                        return (react_1.default.createElement(PunchDeletionConfirmationModal_1.PunchDeletionConfirmationModal, { closeModal: close, punchDateTime: (0, DateManagement_1.createISOWithoutMillisecond)(punchDateTime), acceptPunchDeletion: function () {
                                setPunchToastModalState(PunchToastModalState.DELETE_PUNCH);
                                setHideErrorModal(false);
                                deletePunch((0, DateManagement_1.createISOWithoutMillisecond)(punchDateTime));
                                close();
                            } }));
                    } }),
                i < punchesTimeSegments.length - 1 && react_1.default.createElement(Hr_1.Hr, null)));
        })));
    };
    var renderPunchCorrectionList = function () {
        return expandSection &&
            punchAutomationPolicy &&
            !!(punchCorrections === null || punchCorrections === void 0 ? void 0 : punchCorrections.length) &&
            !!(punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.length) && (react_1.default.createElement(Col_1.Col, { backgroundColor: "neutral05", dataTestId: "missed-punch-corrections", padding: "S300" },
            react_1.default.createElement(Text_1.Text, { fontSize: "T300", margin: { top: 'S200', bottom: 'S200' }, fontWeight: "bold" }, t('time_and_attendance_PunchSection_CorrectionsTitle')),
            react_1.default.createElement(Row_1.Row, { justifyContent: "space-between", gridGap: "S300", margin: { bottom: 'S300' } },
                react_1.default.createElement(Text_1.Text, { fontSize: "T300", color: "neutral80" }, t('time_and_attendance_PunchSection_CorrectionsWarning'))),
            punchCorrections.map(function (punchCorrection, i) { return (react_1.default.createElement(View_1.View, { key: "".concat(punchCorrection.correctionId, "-").concat(i) },
                react_1.default.createElement(PunchCorrectionCard_1.PunchCorrectionCard, { correctionId: punchCorrection.correctionId, correctionDateTime: punchCorrection.correctionDateTime, militaryTime: militaryTime, cardIndex: i, renderPunchCorrectionConfirmationModal: function (_a) {
                        var close = _a.close;
                        return (react_1.default.createElement(PunchCorrectionConfirmationModal_1.PunchCorrectionConfirmationModal, { closeModal: close, correctionDateTimeISO: punchCorrection.correctionDateTime, acceptPunchCorrection: function () {
                                setPunchToastModalState(PunchToastModalState.ACCEPT_PUNCH_CORRECTION);
                                setHideErrorModal(false);
                                acceptPunchCorrection(punchCorrection.correctionId);
                                close();
                            } }));
                    }, renderPunchModal: function (_a) {
                        var close = _a.close;
                        return (react_1.default.createElement(PunchModal_1.PunchModal, { ctkPolicy: ctkPolicy, currentSelectedDate: selectedDate, militaryTime: militaryTime, close: close, submit: function (punchTime, punchDate, useMilitaryTime) {
                                setPunchToastModalState(PunchToastModalState.UPDATE_PUNCH_CORRECTION);
                                setHideErrorModal(false);
                                updatePunchCorrection(punchCorrection.correctionId, (0, DateManagement_1.parsePunchTime)(punchTime, punchDate, useMilitaryTime).toISO());
                                close();
                            }, isMissedPunchModal: false, hasUnverifiedMissedPunchLimit: false, associateInfo: associateInfo }));
                    } }),
                i < punchCorrections.length - 1 && react_1.default.createElement(Hr_1.Hr, null))); })));
    };
    return (react_1.default.createElement(StyledCard, { dataTestId: "PunchSection", key: "PunchSection" },
        punchLoading && react_1.default.createElement(__1.PunchSpinner, null),
        react_1.default.createElement(Col_1.Col, { gridGap: "S300", width: "100%" },
            react_1.default.createElement(views_1.PunchSectionHeader, { punchTotal: punchTotal, missedPunchTotal: missedPunchTotal, onClick: setExpandSectionback, renderModal: renderPunchModal, expandSection: expandSection }),
            renderNoPunchClock(),
            renderPunchList(),
            renderPunchCorrectionList(),
            renderPunchToastModal(),
            renderPunchErrorModal(),
            expandSection && (react_1.default.createElement(Text_1.Text, { color: "neutral70", fontSize: "T200" }, t('time_and_attendance_PunchSection_NoPunchesDescription'))))));
};
exports.PunchSection = PunchSection;
var StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: none;\n"], ["\n    border: none;\n"])));
var StyledClock = (0, Theme_1.styledWithTheme)('img')(function (_a) {
    var theme = _a.theme;
    return "\n    margin: ".concat(theme.selectors.space('S400'), "px 0;\n");
});
var templateObject_1;
